module.exports = __webpack_public_path__ + "static/media/infoCircleOutlined.425870dd.svg";